export default __webpack_public_path__ + "static/media/security-scan.62264354.svg";